<template lang="pug">
.checkout-page
    .main-area.px-4(v-if="areas.main && areas.main.length")
        section.container.mx-auto(v-for="(section, index) in areas.main" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            CheckoutStepper(v-if="section.key === 'checkout'" :section="section")
</template>

<script>
// import { mapGetters } from 'vuex';

import Page from '@/views/Page';
import CheckoutStepper from '@/extensions/shop/components/CheckoutStepper';

export default {
    name: 'Checkout',
    extends: Page,
    components: {
        CheckoutStepper
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
// @import "~@/assets/sass/variables"

.checkout-page
  padding: 3rem 0

section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
